import { render, staticRenderFns } from "./CRProject.vue?vue&type=template&id=bd001170&scoped=true"
import script from "./CRProject.vue?vue&type=script&lang=js"
export * from "./CRProject.vue?vue&type=script&lang=js"
import style0 from "./CRProject.vue?vue&type=style&index=0&id=bd001170&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd001170",
  null
  
)

export default component.exports